/**
  * Radial Progress Bar
  * ===================
  * A circluar loading bar
  *
  * @prop progressPercentage {number} The percentage loaded
  */

export default {
  name: 'radial-progress-bar',

  props:[ 'progressPercentage'],

  mounted: function(){
    window.requestAnimationFrame(this.onAnimationFrame);
  },

  beforeDestroy: function(){
    if(this.animationFrameRequest) window.cancelAnimationFrame(this.animationFrameRequest);
  },

  data: function () {
    return {
      barPosition: 0,
      lastAnimationFrameTime:0,
      displayedPercentage: 0,
      animationFrameRequest: null
    }
  },

  methods: {

    /**
      * The browser is ready to render another frame so  animate the progress bar
      *
      * @param currentTime {int} Timestamp of the current time now
      */
    onAnimationFrame:function(currentTime){

      // Time since last frame
      var deltaTime = (currentTime - this.lastAnimationFrameTime)/1000;
      this.lastAnimationFrameTime = currentTime;

      // Which direction should the bar travel
      var direction = 1;
      if(this.progressPercentage < this.displayedPercentage)
      {
        direction = -1
      }
      else if(this.progressPercentage == this.displayedPercentage)
      {
        direction = 0;
      }

      // Will the bar reach it's target this frame
      var changeInPosition = direction * 100 * deltaTime;
      if((direction < 0 && this.displayedPercentage + changeInPosition < this.progressPercentage)
          || (direction > 0 && this.displayedPercentage + changeInPosition > this.progressPercentage))
      {
        changeInPosition = 0;
        this.displayedPercentage = this.progressPercentage;
      }

      // Move barPosition
      this.displayedPercentage += changeInPosition;

      // Clamp bar between 360 and 0
      if(this.displayedPercentage > 100)
      {
        this.displayedPercentage = 100;
      }
      else if(this.displayedPercentage < 0)
      {
        this.displayedPercentage = 0;
      }

      this.barPosition = this.displayedPercentage/100 * 360;

      // Rotate the left half circle up until 180 degrees
      if( this.barPosition < 180)
      {
        this.$refs.leftHalfCircle.style.transform = 'rotate(' + this.barPosition + 'deg)';
        this.$refs.rightHalfCircle.style.transform = 'rotate(180deg)';
      }
      // Then rotate the right half circle up to 360 degrees
      else
      {
        this.$refs.leftHalfCircle.style.transform = 'rotate(180deg)';
        this.$refs.rightHalfCircle.style.transform = 'rotate(' + this.barPosition + 'deg)';
      }

      // Keep upadting until the bar has rotated 360 degrees
      //if( this.barPosition < 360 )
      this.animationFrameRequest = window.requestAnimationFrame(this.onAnimationFrame);
    },


  }
}



// WEBPACK FOOTER //
// ./src/components/ui/RadialProgressBar/RadialProgressBar.js